import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import {
    HumidityIcon,
    LightIcon,
    PressureIcon,
    RainIcon,
    TemperatureIcon,
    WindIcon,
} from 'app/agriculture/icons';
import { Skeleton } from '@mui/material';
import { DynamicDirectionIcon } from 'app/agriculture/components/StatWithDirection/DynamicDirectionIcon/DynamicDirectionIcon';

export function WeatherDisplaySkeleton() {
    return (
        <SimpleGrid className="WeatherDisplay" columns={3}>
            <StatDisplay
                Icon={TemperatureIcon}
                name="Temperature"
                value={<Skeleton variant="text" animation="wave" width={24} />}
            />
            <StatDisplay
                Icon={LightIcon}
                name="Illuminance"
                value={<Skeleton variant="text" animation="wave" width={48} />}
            />
            <StatDisplay
                Icon={LightIcon}
                name="UV Index"
                value={<Skeleton variant="text" animation="wave" width={24} />}
            />

            <StatDisplay
                Icon={HumidityIcon}
                name="Humidity"
                value={<Skeleton variant="text" animation="wave" width={24} />}
            />
            <StatDisplay
                Icon={RainIcon}
                name="New Rainfall"
                value={<Skeleton variant="text" animation="wave" width={48} />}
            />
            <StatDisplay
                Icon={PressureIcon}
                name="ABS Pressure"
                value={<Skeleton variant="text" animation="wave" width={48} />}
            />
            <StatDisplay
                Icon={(props) => <DynamicDirectionIcon {...props} direction={null} />}
                name="Wind Speed"
                value={<Skeleton variant="text" animation="wave" width={48} />}
            />
            <StatDisplay
                Icon={WindIcon}
                name="Gust Speed"
                value={<Skeleton variant="text" animation="wave" width={48} />}
            />
        </SimpleGrid>
    );
}
